module.exports = __webpack_public_path__ + "static/media/trenazer-rowerowy-elite-direto-xr-t-smart.e8cb046c.jpeg";